module.exports = __webpack_public_path__ + "static/media/course_1.917bd842.mp4";